export default __webpack_public_path__ + "a93d9c581fa35d7f17aa3f94716a353a.svg";